import { render, staticRenderFns } from "./TemplateEditorActionDivider.vue?vue&type=template&id=4817c49f"
import script from "./TemplateEditorActionDivider.vue?vue&type=script&lang=ts"
export * from "./TemplateEditorActionDivider.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports